import React, { useEffect } from 'react';
import PageWrapper from './PageWrapper';
import EditableText from './EditableText';
import { RadarChart } from '../../Feedback360ResultsPage/children/Circumplex/children/radarChart';
import { DonutChart } from '../../Feedback360ResultsPage/children/Circumplex/children/donutChart';
import { FEEDBACK_360_SURVEY } from '../../../../config/questionTypeConstants';

export default function ResultsSummaryPage({ data, personName, chartFontSizes = {}, pageNumber }) {
  const chartContent = data.content[0];
  const {
    subCategoryFontSize, // radar sub-category labels
    axisFontSize,        // radar 1-6 scale numbers
    categoryFontSize,    // donut category labels (COACHING etc.)
  } = chartFontSizes;

  useEffect(() => {
    // amCharts has a 1s appear animation. Wait for it to finish, then signal
    // Puppeteer that the live chart is fully painted and ready to be screenshotted.
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.__circumplexReady = true;
      }
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageWrapper pageNumber={pageNumber} personName={personName}>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        <span className="pdf-section-heading__badge">1</span>
        <EditableText
          as="span"
          path="circumplexData.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="p"
        className="pdf-body-text"
        path="circumplexData.intro"
        variant="block"
        stripInlineWrap
      />
      <EditableText
        as="p"
        className="pdf-body-text"
        path="circumplexData.interpretLead"
        variant="inline"
        stripInlineWrap
      />
      <EditableText
        as="div"
        className="pdf-bullet-list"
        path="circumplexData.interpretBullets"
        variant="block"
      />

      <div className="pdf-circumplex-container" data-circumplex-target>
        <RadarChart
          isForPdfGeneration={true}
          radarChartData={chartContent.radarChartData}
          subCategoryFontSize={subCategoryFontSize}
          axisFontSize={axisFontSize}
          logoUrl={chartContent.logoUrl}
          responsiveLogo={!!chartContent.logoUrl}
          projectType={FEEDBACK_360_SURVEY.MODULAR_360_FEEDBACK}
        />
        <DonutChart
          donutData={chartContent.donutChartData}
          categoryFontSize={categoryFontSize}
          projectType={FEEDBACK_360_SURVEY.MODULAR_360_FEEDBACK}
        />
      </div>

      <div className="pdf-chart-legend">
        <div className="pdf-chart-legend__item">
          <span className="pdf-chart-legend__color" style={{ backgroundColor: '#2E74B5', opacity: 0.3, border: '2px solid #2E74B5' }}></span>
          <span>All But Self scores</span>
        </div>
        <div className="pdf-chart-legend__item">
          <span className="pdf-chart-legend__line" style={{ borderTop: '2px solid #333' }}></span>
          <span>Self scores on the 6-pt scale</span>
        </div>
        <div className="pdf-chart-legend__item">
          <span className="pdf-chart-legend__line" style={{ borderTop: '2px dashed #999' }}></span>
          <span>Norm</span>
        </div>
      </div>
    </PageWrapper>
  );
}
